import { Center, Spinner } from "@chakra-ui/react";

export function OperationListPending() {
  return (
    <Center flex="1" pb="100px">
      <Spinner />
    </Center>
  );
}
